<template lang="pug">
.gzzoc-pdf-wrapper
    .gzzoc-pdf
        img.logo(src="~public/images/gzzoc/logo-pdf.png", width="267")
        .title
            | {{$t('gzzoc.reportTitle')}}
        .person
            .item {{$t('gzzoc.name')}}：{{result.name}}
            .item {{$t('gzzoc.gender')}}: {{result.gender}}
            .item {{$t('gzzoc.age')}}: {{result.age}}{{$t('gzzoc.ageUnit')}}

        .capture-dom(v-if="showCapture")
        .result-wrapper.thin-border-top
            .result-content(v-for='(item, index) in result.report')
                .result-img
                    img(:src="imgsrc(item.img)")
                    span.side {{item.side}}
                .result-item
                    .result-title {{$t('gzzoc.diagnosticSuggest')}}
                    .result-description.has-big-font(:class="resultDescriptionClass")
                        label(v-for='(it, j) in item.diagnosis') {{it.title}}: {{it.explain}}
                .result-item.thin-border-top
                    .result-title {{$t('gzzoc.analysis')}}
                    .result-description(:class="resultDescriptionClass")
                        label(v-for='(it, j) in item.assessment') {{it.title}}: {{it.explain}}
                .result-item.thin-border-top(v-if="item.treatment && item.treatment[0]")
                    .result-title {{item.treatment[0].title}}
                    .result-description.has-big-font(:class="resultDescriptionClass")
                        label {{item.treatment[0].explain}}

        .result-sign(:class="langClass")
            .result-doctorSignature
                span {{$t('gzzoc.doctorSignature')}}:
                img(src="~public/images/gzzoc/Visionome.png")
            .result-data
                span {{$t('gzzoc.date')}}:
                span {{date}}

        .tips.thin-border-top
            .tip-title(v-if="result.model_remark !== ''")  {{$t('visionomeIntroduction')}}：
            .tip-content(v-html='result.model_remark')
</template>

<script>
import _ from 'lodash';
import { languages, loadLanguageAsync } from "@/locale";

export default {
    data () {
        return {
            result: {
                report: []
            },
            showCapture: false
        };
    },
    computed: {
        id () {
            return this.$route.params.taskId;
        },
        date () {
            return this.$route.params.date;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        resultDescriptionClass () {
            return {
                'single-row': this.result.report && this.result.report.length !== 2
            };
        },
        langClass () {
            return {
                'en': this.lang.lang === 'en'
            };
        }
    },
    async mounted () {
        let lang = _.get(this.$route, 'params.lang');
        if (lang) {
            await loadLanguageAsync(lang);
        }
        this.getResult();
    },
    methods: {
        imgsrc (src) {
            return '/api/upl/s3/download/big/file?_id=' + src;
        },
        getResult () {
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: this.id,
                    lang: this.lang.lang
                }
            }).then(resp => {
                const status = _.get(resp, 'body.value.data.status');
                // 成功
                if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    this.result = result;
                    return;
                }
            }).finally(() => {
                this.$nextTick(() => {
                    setTimeout(() => { // 解决截图中存在loading状态的bug
                        this.showCapture = true;
                    }, 300);
                });
            });
        }
    }

};
</script>

<style lang="sass" scoped>
.gzzoc-pdf-wrapper
    width: 100%
    height: 100%
    background-color: #FFF
    overflow-y: hidden
.gzzoc-pdf
    background-color: #FFF
    margin: 0 auto
    color: #000
    transform-origin: top center
    transform: scale(0.8, 0.8)
    .logo
        width: 196px
        height: 28px
    .title
        font-family: STSongti-SC-Black
        font-size: 24px
        color: #000
        text-align: center
        line-height: 24px
        margin-top: 21px
        white-space: pre-wrap
    .person
        font-family: STSongti-SC-Regular
        font-size: 12px
        color: #000000
        line-height: 12px
        text-align: center
        padding-bottom: 15px
        margin-top: 20px
        display: flex
        justify-content: center
        .item
            display: inline-block
            margin: 0 30px
    .result-wrapper
        padding-top: 20px
        display: flex
        flex: 1 1
        justify-content: center
        .result-content
            &:not(:last-child)
                margin-right: 34px
        .result-img
            margin: 0 auto
            display: flex
            flex-direction: column
            align-items: center
            img
                width: 340px
                height: 340px
                background: #EEE
                justify-content: center
                vertical-align: middle
                object-fit: contain
            .side
                font-family: STSongti-SC-Regular
                font-size: 12px
                color: #000
                text-align: center
                margin-top: 10px

        .result-item
            color: #000
            padding-top: 10px
            padding-bottom: 10px
            &:first-child
                padding-top: 20px
            &:last-child
                padding-bottom: 0px
            .result-title
                font-family: STSongti-SC-Regular
                font-size: 12px
                line-height: 17px
                color: #000000
            .result-description
                font-family: STSongti-SC-Regular
                font-size: 12px
                color: #000000
                label
                    line-height: 17px
                    vertical-align: top
                    margin-top: 5px
                    display: inline-block
                    width: 45%
                    margin-right: 5%
                &.single-row
                    label
                        width: 23%
                        margin-right: 2%
                &.has-big-font
                    label:first-child
                        font-size: 18px
                        line-height: 25px
                        display: block
                        width: 100%
                &.result-small-text
                    font-size: 16px
                    line-height: 17px

    .result-sign
        float: right
        font-size: 12px
        color: #666
        line-height: 24px
        width: 190px
        margin-bottom: 10px
        margin-top: 27px
        img
            width: 132px
            height: 24px
            margin-left: 5px
    .tips
        clear: both
        padding-top: 20px
        color: #000
        font-size: 10px
        line-height: 14px
        .tip-content
            margin-top: 5px
        .tip-warm
            margin-top: 5px
</style>
